'use client';

import React, { useMemo } from 'react';
import dynamic from 'next/dynamic';

import styles from '../index.module.scss';

type PropertyMapProps = {
  latitude: string | number;
  longitude: string | number;
  propertyName: string;
};

export const PropertyMap = ({
  latitude,
  longitude,
  propertyName,
}: PropertyMapProps) => {
  const Map = useMemo(
    () =>
      dynamic(() => import('../map'), {
        loading: () => null,
        ssr: false,
      }),
    [],
  );

  return (
    <div className={styles.map}>
      <Map
        posix={[+latitude, +longitude]}
        zoom={15}
        popupLabel={propertyName}
      />
    </div>
  );
};
